const premiumWorkouts = [
  {
    id: 'premium-1',
    name: 'Advanced Strength & Mobility',
    tier: 'elite',
    duration: 30,
    level: 'Intermediate',
    focusArea: 'Strength',
    description: 'Progressive strength training with mobility exercises for seniors',
    thumbnailUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=500&q=60',
    exercises: [
      {
        id: 'deadlift',
        name: 'Deadlift',
        description: 'Master the deadlift for overall strength and posture improvement',
        sets: 4,
        reps: 8,
        restSeconds: 90,
        focusAreas: ['Back', 'Legs', 'Core'],
        videoId: '05b8bf2640136c3bcad7fd878012fa58', // Deadlifts
        platform: 'cloudflare',
        diagramUrl: 'deadlift.svg',
        instructions: 'Stand with feet hip-width apart, hold weights, hinge at hips to lower weights toward the ground, then return to standing.'
      },
      {
        id: 'plank-db-taps',
        name: 'Plank DB Taps',
        description: 'Enhance core stability and shoulder strength',
        sets: 3,
        reps: 10,
        restSeconds: 60,
        focusAreas: ['Core', 'Shoulders', 'Stability'],
        videoId: '5b80a98593c41b109548841670874be0', // Plank Dumbbell Tap
        platform: 'cloudflare',
        diagramUrl: 'plank-db-taps.svg',
        instructions: 'Hold a plank position, alternately tap dumbbells with each hand while maintaining core stability.'
      },
      {
        id: 'wood-choppers',
        name: 'Wood Choppers',
        description: 'Improve rotational strength and core power',
        sets: 3,
        reps: 12,
        restSeconds: 45,
        focusAreas: ['Core', 'Rotation', 'Strength'],
        videoId: '4f0915ded7de806e975158fc5bd8a000', // Wood Chopper
        platform: 'cloudflare',
        diagramUrl: 'wood-choppers.svg',
        instructions: 'Hold a weight with both hands, rotate from high to low across your body in a chopping motion.'
      },
      {
        id: 'mountain-climbers',
        name: 'Mountain Climbers',
        description: 'Boost cardiovascular fitness and core strength',
        sets: 3,
        reps: 20,
        restSeconds: 60,
        focusAreas: ['Cardio', 'Core', 'Full Body'],
        videoId: 'bd3db7dbe4a81b9804ece412c69557a6', // Mountain Climbers
        platform: 'cloudflare',
        diagramUrl: 'mountain-climbers.svg',
        instructions: 'Start in plank position, alternate bringing knees to chest in a running motion.'
      }
    ],
    focusAreas: ['Strength', 'Mobility'],
    estimatedDuration: 30
  },
  {
    id: 'gentle-cardio-basics',
    name: 'Gentle Cardio Basics',
    tier: 'premium',
    duration: 20,
    level: 'Beginner',
    focusArea: 'Cardiovascular',
    description: 'Slow-tempo cardio that eases you into movement with controlled pacing, pain-free ranges, and calm breathing cues so joints stay happy while your heart gets stronger.',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/v1762732114/image_11_kht9n2.jpg',
    exercises: [
      {
        id: 'seated-marching-gentle',
        name: 'Seated Marching',
        description: 'Gentle marching in place while seated',
        sets: 3,
        reps: 20,
        restSeconds: 30,
        focusAreas: ['Legs', 'Cardiovascular'],
        videoId: 'seated-marching-basic',
        platform: 'cloudflare',
        diagramUrl: 'seated-marching.svg',
        instructions: 'Sit tall with feet planted. Float one knee upward over a slow 3-count, pause for a breath, then lower over a 3-count before switching legs. Stay in a pain-free range and rest if breathing becomes strained.'
      },
      {
        id: 'gentle-arm-raises',
        name: 'Gentle Arm Raises',
        description: 'Slow arm raises to improve circulation',
        sets: 2,
        reps: 12,
        restSeconds: 30,
        focusAreas: ['Arms', 'Cardiovascular'],
        videoId: 'gentle-arm-raises',
        platform: 'cloudflare',
        diagramUrl: 'arm-raises.svg',
        instructions: 'Sit or stand comfortably. Glide arms to shoulder height over a 4-count, pause softly, then lower on another 4-count while exhaling. Stop before shoulders feel tight and shake out tension between sets.'
      },
      {
        id: 'slow-walking',
        name: 'Slow Walking',
        description: 'Gentle walking at a comfortable pace',
        sets: 1,
        reps: 5,
        restSeconds: 0,
        focusAreas: ['Cardiovascular', 'Endurance'],
        videoId: 'slow-walking',
        platform: 'cloudflare',
        diagramUrl: 'walking.svg',
        instructions: 'Walk in place or around your room using a calm inhale for three steps and exhale for three. Keep strides short, stay pain-free, and pause immediately if joints or balance feel uncertain.'
      }
    ],
    focusAreas: ['Cardiovascular', 'Endurance', 'Mobility'],
    estimatedDuration: 20,
    trainingGuidelines: [
      'Use 3- to 4-second tempos so muscles—not momentum—drive every rep.',
      'Stay in pain-free ranges; if breathing or joints feel strained, pause, reset posture, and resume gently.',
      'Log how you feel after each session and schedule a light recovery day before repeating.'
    ],
    progression: 'This is your starting point! Build confidence with the measured pacing outlined above, take breaks when needed, and only increase depth or speed when every rep feels smooth and controlled.'
  },
  {
    id: 'moderate-cardio-progress',
    name: 'Moderate Cardio Progress',
    tier: 'premium',
    duration: 25,
    level: 'Intermediate',
    focusArea: 'Cardiovascular',
    description: 'Keep progressing with slow, deliberate pacing—slightly more challenging cardio done smooth, controlled, and always within a comfortable range.',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/v1762732630/image_12_qze5zp.jpg',
    exercises: [
      {
        id: 'standing-marching',
        name: 'Standing Marching',
        description: 'March in place while standing for increased intensity',
        sets: 3,
        reps: 30,
        restSeconds: 45,
        focusAreas: ['Legs', 'Cardiovascular'],
        videoId: 'standing-marching',
        platform: 'cloudflare',
        diagramUrl: 'standing-marching.svg',
        instructions: 'Stand tall with feet hip-width. Float each knee up over a 3- to 4-count, gently lower on the same tempo, and keep arms gliding in sync. Stop short of hip tightness and breathe steadily throughout.'
      },
      {
        id: 'arm-circles',
        name: 'Arm Circles',
        description: 'Circular arm movements to increase heart rate',
        sets: 2,
        reps: 15,
        restSeconds: 30,
        focusAreas: ['Arms', 'Shoulders', 'Cardiovascular'],
        videoId: 'arm-circles',
        platform: 'cloudflare',
        diagramUrl: 'arm-circles.svg',
        instructions: 'Extend arms at shoulder height and trace circles over four slow counts in each direction, focusing on smooth shoulders and relaxed fingers. Reduce the circle size if joints feel cranky.'
      },
      {
        id: 'brisk-walking',
        name: 'Brisk Walking',
        description: 'Walking at a moderate pace to build endurance',
        sets: 1,
        reps: 8,
        restSeconds: 0,
        focusAreas: ['Cardiovascular', 'Endurance'],
        videoId: 'brisk-walking',
        platform: 'cloudflare',
        diagramUrl: 'brisk-walking.svg',
        instructions: 'Walk at a conversational pace, inhaling for three steps and exhaling for three. Keep strides short, spine tall, and downshift instantly if breath or joints feel taxed.'
      },
      {
        id: 'step-touches',
        name: 'Step Touches',
        description: 'Side-to-side stepping movements',
        sets: 2,
        reps: 20,
        restSeconds: 30,
        focusAreas: ['Legs', 'Cardiovascular', 'Coordination'],
        videoId: 'step-touches',
        platform: 'cloudflare',
        diagramUrl: 'step-touches.svg',
        instructions: 'Glide side-to-side with a smooth 4-count in each direction, tapping the floor gently before switching. Keep knees softly bent, hips level, and shoulders relaxed.'
      }
    ],
    focusAreas: ['Cardiovascular', 'Endurance', 'Coordination'],
    estimatedDuration: 25,
    trainingGuidelines: [
      'Maintain 3- to 4-second tempos so muscles stay engaged without jolting joints.',
      'Check in with rate of perceived exertion every few minutes; if it climbs too high, pause and reset.',
      'Alternate effort days with active recovery walks or mobility sessions to lock in progress.'
    ],
    progression: 'You\'re building momentum! Stick with the deliberate pacing cues, keep breathing smooth, and only progress when every rep feels controlled and repeatable.'
  },
  {
    id: 'active-cardio-challenge',
    name: 'Active Cardio Challenge',
    tier: 'premium',
    duration: 30,
    level: 'Advanced',
    focusArea: 'Cardiovascular',
    description: 'Dial up intensity without sacrificing control—dynamic cardio performed on slow tempos with deliberate recovery pacing.',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/v1762733339/image_uf10ly.jpg',
    exercises: [
      {
        id: 'high-knee-marching',
        name: 'High Knee Marching',
        description: 'Energetic marching with higher knee lifts',
        sets: 3,
        reps: 40,
        restSeconds: 60,
        focusAreas: ['Legs', 'Cardiovascular', 'Core'],
        videoId: 'high-knee-marching',
        platform: 'cloudflare',
        diagramUrl: 'high-knee-marching.svg',
        instructions: 'March in place, lifting knees toward your chest over a controlled 3-count up and 3-count down while keeping core braced. Ease range if hips or balance feel challenged and match breath to the rhythm.'
      },
      {
        id: 'arm-pumps',
        name: 'Arm Pumps',
        description: 'Dynamic arm movements to increase intensity',
        sets: 2,
        reps: 20,
        restSeconds: 45,
        focusAreas: ['Arms', 'Cardiovascular', 'Shoulders'],
        videoId: 'arm-pumps',
        platform: 'cloudflare',
        diagramUrl: 'arm-pumps.svg',
        instructions: 'March lightly and sweep arms through powerful arcs over four slow counts, exhaling as hands travel downward. Keep shoulders relaxed and pause if posture breaks.'
      },
      {
        id: 'side-steps',
        name: 'Side Steps',
        description: 'Lateral stepping movements for full-body cardio',
        sets: 2,
        reps: 25,
        restSeconds: 45,
        focusAreas: ['Legs', 'Cardiovascular', 'Balance'],
        videoId: 'side-steps',
        platform: 'cloudflare',
        diagramUrl: 'side-steps.svg',
        instructions: 'Glide side-to-side with a light 4-count rhythm, pausing softly before changing direction. Keep knees soft, weight centred, and adjust depth to stay pain-free.'
      },
      {
        id: 'brisk-walking-advanced',
        name: 'Brisk Walking Advanced',
        description: 'Sustained walking at a challenging pace',
        sets: 1,
        reps: 12,
        restSeconds: 0,
        focusAreas: ['Cardiovascular', 'Endurance'],
        videoId: 'brisk-walking-advanced',
        platform: 'cloudflare',
        diagramUrl: 'brisk-walking-advanced.svg',
        instructions: 'Walk at a pace that nudges your heart rate yet allows a conversation. Use a 3-step inhale / 3-step exhale cadence and back off instantly if breathing becomes jagged.'
      },
      {
        id: 'cool-down-walk',
        name: 'Cool Down Walk',
        description: 'Gentle walking to gradually lower heart rate',
        sets: 1,
        reps: 3,
        restSeconds: 0,
        focusAreas: ['Cardiovascular', 'Recovery'],
        videoId: 'cool-down-walk',
        platform: 'cloudflare',
        diagramUrl: 'cool-down-walk.svg',
        instructions: 'Finish with a 3-minute stroll, slowing each step over a 4-count while inhaling through the nose and exhaling through the mouth to bring heart rate down gradually.'
      }
    ],
    focusAreas: ['Cardiovascular', 'Endurance', 'Strength', 'Balance'],
    estimatedDuration: 30,
    trainingGuidelines: [
      'Open each session with a readiness check—if joints feel stiff, add an extra warm-up circuit before intensity work.',
      'Maintain deliberate tempos (no faster than a 3-count up / 3-count down) so muscles absorb the workload.',
      'Schedule at least one low-intensity or rest day between challenge sessions to respect recovery.'
    ],
    progression: 'You\'ve built up to this level! Keep that slow, intentional control front and centre, downshift when form fades, and revisit earlier sessions anytime you need a lighter stimulus.'
  },
  {
    id: 'core-strength-mastery',
    name: 'Core Strength Mastery',
    tier: 'premium',
    duration: 35,
    level: 'Expert',
    focusArea: 'Cardiovascular',
    description: 'Master-level cardio-core work delivered with slow, precise tempos that tax the muscles while keeping joints safe.',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/v1762733652/image_13_g3kkec.jpg',
    exercises: [
         {
           id: 'leg-raises',
           name: 'Leg Raises',
           description: 'Strengthen lower abs and hip flexors',
           sets: 3,
           reps: 15,
           restSeconds: 45,
           focusAreas: ['Core', 'Legs'],
           videoId: '009c5ff3ee1bfcf375b0d9abd1a8c05e', // Fitspiration Leg Raises (exact same exercise)
           platform: 'cloudflare',
           diagramUrl: 'leg-raises.svg',
           instructions: 'Lie on your back, brace your core, and raise legs toward the ceiling over a 4-count, pause, then lower over another 4-count stopping before your back arches. Shorten the range if hips or spine protest.'
         },
         {
           id: 'russian-twists',
           name: 'Russian Twists',
           description: 'Improve core rotation and stability',
           sets: 3,
           reps: 20,
           restSeconds: 30,
           focusAreas: ['Core', 'Rotation'],
           videoId: '61a82a8013d6652e5b2874bfdcc50dc3', // Fitspiration Russian Twists (exact same exercise)
           platform: 'cloudflare',
           diagramUrl: 'russian-twists.svg',
           instructions: 'Sit tall with heels on the floor, lean back slightly, and rotate shoulders side-to-side over a 4-count each way. Keep breath steady, move pain-free, and lighten the weight if control slips.'
         },
         {
           id: 'weighted-crunch',
           name: 'Weighted Crunch',
           description: 'Strengthen your core with weighted crunches',
           sets: 3,
           reps: 20,
           restSeconds: 30,
           focusAreas: ['Core', 'Strength'],
           videoId: 'a1f84f3fb01045cf45f71f0cb1e6b833', // Fitspiration Weighted Crunch (exact same exercise)
           platform: 'cloudflare',
           diagramUrl: 'weighted-crunch.svg',
           instructions: 'Lie supine holding a light weight at the chest. Curl up over a 4-count, pause to breathe out, then lower over a 4-count keeping chin softly tucked. Begin bodyweight-only until the tempo feels easy.'
         }
    ],
    focusAreas: ['Cardiovascular', 'Endurance', 'Core Strength'],
    estimatedDuration: 35,
    trainingGuidelines: [
      'Perform every rep on a 4- to 5-second ascent and descent so deep core muscles—not momentum—do the work.',
      'Stay within a pain-free range and pause immediately if the low back, hips, or neck feel strained.',
      'Allow at least 48 hours between mastery sessions, filling recovery days with gentle walking or mobility.'
    ],
    progression: 'This is the most advanced level! Keep the slow pacing consistent, add load only when the tempo feels rock-solid, and regress instantly if form or comfort falters.'
  }
];

export { premiumWorkouts };
